var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","ma-1":""}},[_c('v-card',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":"","title":"","pa-2":""}},[_c('mrx-translation',{attrs:{"token":'questions.malaria.child_test_id'}}),_vm._v("   "),_c('v-flex',[_vm._v(_vm._s(_vm.childTestId))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }